import { create } from 'zustand';
import { createLoadingSlice, type LoadingSlice } from '@/stores/loading-slice';
import {
  createUserPreferencesSlice,
  type UserPreferencesSlice,
} from '@/stores/preferences-slice';

export type AppStoreState = UserPreferencesSlice & LoadingSlice;

export const useBoundStore = create<AppStoreState>((...a) => ({
  ...createUserPreferencesSlice(...a),
  ...createLoadingSlice(...a),
}));
